import React from 'react';

function CheckIcon(props) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path id="Vector" d="M19.9,3.3c-0.2-0.4-0.5-0.7-1-0.8c-0.1,0-0.3,0-0.4,0c-0.3,0-0.5,0.2-0.8,0.4l-4,4.3c-2.2,2.3-4.4,4.7-6.6,7c-1.3-1.4-2.6-2.7-3.9-4.1l-1-1.1C1.9,8.8,1.7,8.7,1.4,8.7c-0.1,0-0.3,0-0.4,0c-0.2,0-0.3,0.1-0.5,0.2C0.3,9,0.1,9.4,0,9.8C0,10.2,0.1,10.7,0.4,11c1.9,2,3.9,4.1,5.8,6.1c0.3,0.3,0.6,0.4,0.9,0.4c0.3,0,0.7-0.1,0.9-0.4c1.1-1.2,2.2-2.4,3.4-3.6l1.3-1.3c0.4-0.4,0.7-0.8,1.1-1.2c0.8-0.9,1.7-1.8,2.6-2.7c0.4-0.4,0.8-0.9,1.2-1.3c0.8-0.8,1.7-1.7,2.4-2.7L20,4.2V3.4L19.9,3.3L19.9,3.3z"/>
    </svg>
  );
}

export default CheckIcon;
